import type { IOnlineUser } from 'packages/workspace/services/models/account';
import useSession from 'packages/workspace/services/store/session-store';
import { UseQueryResult, useQuery } from 'react-query';
import type { ResponseFormat } from './../../../services/models/global-models';

import { Http } from './../../prelude/http/index';
import { InternalConversationStore } from 'packages/workspace/services/store/omnichannel/internal-conversation-store';

export const fetchOtherOperators = async (): Promise<Array<IOnlineUser>> => Http.Request<ResponseFormat<Array<IOnlineUser>>>('GET', `/workspaces/api/v1/internal-users.list`).then((res) => res.data);

/**
 * Get Operators
 */
export default function useOnlineUsers(): UseQueryResult<Array<IOnlineUser>> {
  const session = useSession();
  return useQuery(['onlineUsers'], () => fetchOtherOperators(), {
    staleTime: Number.POSITIVE_INFINITY,
    select: (data: Array<IOnlineUser>) => {
      if (session.iamPrincipal) {
        const sortedUsers = data.sort((a, b) => {
          if (a.online === b.online) {
            return a.display_name.localeCompare(b.display_name);
          }
          return a.online ? -1 : 1;
        });
        return sortedUsers.filter((user) => user.id !== session.iamPrincipal.id);
      }
      return [];
    },
  });
}
